export const COLOR_PRIMARY = '#03B0F7'
export const COLOR_L_PRIMARY = '#EDF9FE'

const colors = {
    danger: "#DC0032",
    success: "#5CB800",
    warning: "#F7941D",
    primary: '#03b0f7',
    grey: "#D9D9D9",
    technorama: "#f7931d",
    orange: "#F57F29",
    black: '#212529',
    purple: "#8678ab",
    green :'#009106',
    // danger: '#E61D01'
}

export {
    colors
}
